import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent, ListTableComponent, ListTableDataLoader } from '@ppl/ui';
import { map } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { ENDPOINTS } from 'src/app/shared/constants/url.constants';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';

@Component({
    imports: [ListTableComponent, ButtonComponent],
    selector: 'ppl-mass-batch-error-list',
    templateUrl: './mass-batch-error-list.component.html',
    styleUrls: ['./mass-batch-error-list.component.css']
})
export class MassBatchErrorListComponent {
    programName = '';
    lazyLoad = true;
    sharedDataKey = 'list_mass_adjustments_errors';
    showDeleteDialog = false;
    deleteMessage = '';
    batchToDelete = '';
    private batchInstanceId = '';

    constructor(
        private userService: UserService,
        private router: Router,
        private http: HttpRequestService
    ) { }

    massAdjustmentsDataLoader: ListTableDataLoader = (payload, context) => {
        const requestPayload = this.addBatchFilter(payload);
        return this.http
            .post(ENDPOINTS.LIST_PAGE_DATA, requestPayload, context?.hasUpdatedEntry)
            .pipe(map((response) => this.ensureGridColumns(response)));
    };

    ngOnInit(): void {
        const selectedProgram = this.userService.getSelectedProgram();
        this.programName = selectedProgram?.program_code ?? '';
        this.batchInstanceId = this.router.getCurrentNavigation()?.extras?.state?.['batchInstanceId']
            ?? history.state?.batchInstanceId
            ?? '';
    }

    goBack(): void {
        this.router.navigate(['/home/bulkAdjustments']);
    }

    private addBatchFilter(payload: any): any {
        if (!this.batchInstanceId) {
            return payload;
        }

        const searchParam = Array.isArray(payload?.searchParam) ? [...payload.searchParam] : [];
        const hasBatchFilter = searchParam.some((item: any) => item?.jsonPath === 'batchInstanceId');

        if (!hasBatchFilter) {
            searchParam.push({
                jsonPath: 'batchInstanceId',
                value: this.batchInstanceId,
                operator: 'Equal'
            });
        }

        return {
            ...payload,
            searchParam
        };
    }

    private ensureGridColumns(response: any): any {
        if (Array.isArray(response?.GridColumns) && response.GridColumns.length > 0) {
            return response;
        }

        const firstRow = Array.isArray(response?.responsedata)
            ? response.responsedata.find((row: any) => row && typeof row === 'object')
            : undefined;

        if (!firstRow) {
            return response;
        }

        const preferredFields = ['batchInstanceId', 'error', 'status', 'modifiedBy', 'modifiedDate'];
        const keys = Object.keys(firstRow);
        const orderedFields = [...preferredFields.filter((field) => keys.includes(field)), ...keys.filter((field) => !preferredFields.includes(field))];

        return {
            ...response,
            GridColumns: orderedFields.map((field) => ({
                dataColumnName: field,
                gridColumnName: this.getHeaderLabel(field)
            }))
        };
    }

    private getHeaderLabel(field: string): string {
        return field
            .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (character) => character.toUpperCase());
    }
}
